<template>
  <v-footer class="app-background-color footer">
    <!--    <div class="caption accent&#45;&#45;text px-4">-->
    <span class="caption accent--text px-4">
      © {{ new Date().getFullYear() }}, Сервис проведения мероприятий
    </span>
    <!--    </div>-->
  </v-footer>
</template>

<script>
export default {
  name: 'TheFooter',

  data: () => ({}),
}
</script>
